//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.type

import com.apollographql.apollo.api.CustomScalarType

/**
 * The `Int` scalar type represents non-fractional whole numeric values.
 */
public class GraphQLInt {
  public companion object {
    public val type: CustomScalarType = CustomScalarType("Int", "kotlin.Int")
  }
}
